import { get, post } from '../request';
import { SYSTEM_NOTICE_URL, NOTICE_URL } from '../url_config';
// 官网登录页查询消息列表
export async function getSystemNotice_api(params: any) {
  return get(`${SYSTEM_NOTICE_URL}/${params.stationCode}`, params);
}
// 查询消息列表
export async function getNoticeList_api(params?: any) {
  return get(`${NOTICE_URL}`, params);
}
// 标记已读
export async function getNoticeRead_api(params: any) {
  return post(`${NOTICE_URL}/read`, params);
}
/**
 * 订阅上新
 */
// 订阅上新通知
export async function postNewFuncNoticeOss_api(params?: any) {
  return post('app-api/newFunc/notice/OSS', params);
}
// 查询是否已经订阅上新通知
export async function getNewFuncNoticeOss_api(params?: any) {
  return get('app-api/newFunc/notice/OSS', params);
}
